import React from 'react'

import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles'

import Badge from 'components/Badge'

import autosubIcon from './assets/autosub_icon.svg'

interface Props {
  value: number
}

const styles = createStyles({
  badge: {
    top: 0,
    right: 0,
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const AutoSubCount: React.SFC<InjectedProps> = ({ value, classes: { badge } }) => (
  <Badge badgeContent={value} color="primary" classes={{ badge }}>
    <img alt="" src={autosubIcon} style={{ width: 50, height: 32 }} />
  </Badge>
)

export default withStyles(styles)(AutoSubCount)
